module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/whitelist_de.json
// module id = 335
// module chunks = 0